import type { Pagination } from "@/models/user.model";

export type BalanceHistoryType =
  | "DepositCredit"
  | "WithdrawalDebit"
  | "DepositReversal"
  | "WithdrawalReversal"
  | "TransferSent"
  | "TransferReceived";

export type BalanceHistoryRelatedEntityType =
  | "Deposit"
  | "Withdrawal"
  | "Transfer";

export type BalanceHistoryMovementType =
  | "Deposit"
  | "Withdrawal"
  | "Transfer";

export interface BalanceHistoryItem {
  id: string;
  userId: string;
  userFullName: string;
  type: BalanceHistoryType;
  amount: number;
  balanceBefore: number;
  balanceAfter: number;
  relatedEntityId: string | null;
  relatedEntityType: BalanceHistoryRelatedEntityType | null;
  description: string;
  referenceNumber: string | null;
  createdAt: string;
}

export interface BalanceHistoryListParams {
  page?: number;
  pageSize?: number;
  userId?: string;
  type?: BalanceHistoryMovementType;
  referenceNumber?: string;
  dateFrom?: string;
  dateTo?: string;
}

interface BalanceHistoryApiPagination {
  currentPage?: number;
  page?: number;
  pageSize: number;
  totalItems?: number;
  total?: number;
  totalPages: number;
  hasPrevious?: boolean;
  hasNext?: boolean;
}

export interface BalanceHistoryApiResponse {
  items: BalanceHistoryItem[];
  pagination: BalanceHistoryApiPagination;
}

export interface PaginatedBalanceHistory {
  items: BalanceHistoryItem[];
  pagination: Pagination;
}

export const normalizeBalanceHistoryPagination = (
  pagination: BalanceHistoryApiPagination,
  params: BalanceHistoryListParams = {}
): Pagination => {
  const page = pagination.page ?? pagination.currentPage ?? params.page ?? 1;
  const total = pagination.total ?? pagination.totalItems ?? 0;

  return {
    page,
    pageSize: pagination.pageSize ?? params.pageSize ?? 10,
    total,
    totalPages: pagination.totalPages ?? 1,
    hasPrevious: pagination.hasPrevious ?? page > 1,
    hasNext: pagination.hasNext ?? page < (pagination.totalPages ?? 1),
  };
};
